import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  mt: (p) => p.spacing(1.5),
};
